import { React, useState } from "react";
import AdminDashboardLayout from "../../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../../dashboard/dashboard.styled";
import { IntroductionHeader } from "../../dashboard/Dashboard";
import FormAccordion from "../../../components/Form/FormAccordion";
import { AddproductWrapper } from "../../Products/ProductsPage.styled";
import { AddContentTemplate } from "../Education.styled";
import NoticeBar from "../Partials/NoticeBar";
import {
	InputField,
	TextAreaField,
} from "../../../components/Form/FormComponents";
import { AiOutlineSave } from "react-icons/ai";
import { ImCancelCircle } from "react-icons/im";
import {
	ButtonGroup,
	CustomButton,
} from "../../Products/Forms/ProductForm.styled";
import { useNavigate } from "react-router";
import SingleContent from "../Partials/SingleContent";
import "../../../../node_modules/video-react/dist/video-react.css";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import Parse from "../../../api/ApiConfig";
import { toast } from "react-toastify";
import Switch from "@mui/material/Switch";
// eslint-disable-next-line no-unused-vars
import { contentProps, generateId, formatDuration } from "../utils";
import { Capitalize } from "../../Products/ProductUtils/CategoriesUtils";
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";

function AddVideo() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [chapters, setChapters] = useState([]);
	const [formData, setFormData] = useState({});
	const [videoSrc, setVideoSrc] = useState("");
	const [checked, setChecked] = useState(false);
	const [isChapterActive, setChapterActive] = useState(false);
	const [thumbnailUrl, setThumbnailUrl] = useState("");
	const [isThumbnailSaved, setIsThumbnailSaved] = useState(false);
	const [isVideoSaved, setIsVideoSaved] = useState(false);

	// eslint-disable-next-line no-unused-vars
	const [duration, setDuration] = useState();

	const handleToggle = (e) => {
		//display chapters if toggle is set to true
		if (e.target.checked) {
			setChapterActive(true);
			createChapterTemplate();
			setIsVideoSaved(false);
			setDuration("");
			// setIsThumbnailSaved(false);
			setFormData({ ...formData, link: "" }); //remove url once you activate chapters
		}
		//hide chapter sections
		else {
			setVideoSrc("");
			// setThumbnailUrl("");
			setChapters([]);
			setChapterActive(false);
		}
		setChecked(e.target.checked);
	};

	//upload video
	const onChange = (info) => {
		if (info.file.status !== "done") {
			const url = URL.createObjectURL(info?.file);
			setVideoSrc(url);
			saveContentToParse(info); //set actual upload file to parse
		}
	};
	const beforeUpload = (file) => {
		const url = URL.createObjectURL(file);
		setVideoSrc(url);
		return false;
	};
	const handleLoadedMetadata = (e) => {
		setDuration(e.target.duration);
	};

	//create new template
	const createChapterTemplate = () => {
		setChapters((oldData) => [
			...oldData,
			{
				name: "",
				description: "",
				link: "",
				duration: "",
				chapter: "",
				coverPhoto: "",
				id: generateId(),
			},
		]);
	};

	//handle video without chapters
	const handleVideoData = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const saveContentToParse = async (data) => {
		dispatch(setLoadingState(true));
		try {
			const sanitizedFileName = data?.file.name.replace(/[^\w.-]+/g, "");
			const ContentFile = new Parse.File(sanitizedFileName, data?.file);
			console.log(ContentFile);
			await ContentFile.save();
			console.log(ContentFile?._url);
			setFormData({ ...formData, link: ContentFile?._url }); //save video url on upload of a video
			toast.success("video file saved successfully");
			setIsVideoSaved(true);
			dispatch(setLoadingState(false));
		} catch (error) {
			dispatch(setLoadingState(false));
			console.log(error);
			toast.error("unable to save video file, please try again later");
			console.error("Error saving item:", error);
		}
	};

	const getChaptersDuration = () => {
		let sum = 0;
		for (let i = 0; i <= chapters.length - 1; i++) {
			sum += parseInt(chapters[i].duration);
		}
		return sum;
	};

	//save data to db
	const uploadContent = (e) => {
		e.preventDefault();
		//check if user has uploaded a video
		if (!checked && !videoSrc) {
			toast.error("please ensure you upload a video file");
			return;
		}
		//check if user uploaded a thumbail for the image
		if ((!checked && !thumbnailUrl) || (checked && !isThumbnailSaved)) {
			toast.error("please ensure you upload the video thumbnail");
			return;
		}

		//check if user uploaded video and thumbnail when chapters is activated
		if (checked && chapters.length > 0) {
			let areDetailsFilled = true;
			for (let i = 0; i <= chapters.length - 1; i++) {
				if (!chapters[i].link || !chapters[i].coverPhoto) {
					toast.error(
						"seems like you activated the chapters section, please ensure you upload a video file and a thumbnail for each chapter"
					);
					areDetailsFilled = false;
					break;
				}
			}
			if (!areDetailsFilled) {
				return;
			}
		}
		dispatch(setLoadingState(false));
		const Education = Parse.Object.extend("Education");
		const education = new Education();
		education
			.save({
				...formData,
				courseType: "video",
				chapters: chapters,
				category: Capitalize(formData?.category),
				totalDuration: duration
					? formatDuration(duration)
					: formatDuration(getChaptersDuration()),
			})
			.then(
				// eslint-disable-next-line no-unused-vars
				(prod) => {
					dispatch(setLoadingState(false));
					toast.success(
						"Content updated successfully, check table to see updated list"
					);
					navigate("/education/video");
				},
				(error) => {
					console.log(error);
					dispatch(setLoadingState(false));
					toast.error("An error occured while uploading the content");
				}
			);
	};

	const thumbnailUpload = (e) => {
		const file = e.target.files[0];
		const reader = new FileReader();
		reader.onload = () => {
			setThumbnailUrl(reader.result);
		};
		if (file) {
			// console.log(file)
			reader.readAsDataURL(file);
			saveImageToParse(file);
		}
	};

	const saveImageToParse = async (file) => {
		dispatch(setLoadingState(true));
		try {
			const sanitizedFileName = file.name.replace(/[^\w.-]+/g, "");
			const imageFile = new Parse.File(sanitizedFileName, file);
			await imageFile.save();
			setFormData({ ...formData, coverPhoto: imageFile?._url }); //save image url on uploaded thumbnail
			dispatch(setLoadingState(false));
			toast.success("Video thumbnail Saved");
			setIsThumbnailSaved(true);
		} catch (error) {
			dispatch(setLoadingState(false));
			toast.error("unable to video thumbnail, please try again later", error);
			console.error("Error saving item:", error);
		}
	};

	{
		/* eslint-disable no-mixed-spaces-and-tabs  */
	}
	return (
		<AdminDashboardLayout>
			<DashboardWrapper>
				<IntroductionHeader nav={true} />
				<AddproductWrapper className='mt-10'>
					<FormAccordion title='Upload Video Content' open={true}>
						<AddContentTemplate>
							<div className='leftSection'>
								<NoticeBar
									text={
										"You can create your video with a single or in chapters, activate the chapter to start uploading content in chapters"
									}
								/>
							</div>

							<form onSubmit={uploadContent} className='RightSection'>
								<div className='form-group'>
									<label>TITLE</label>
									<InputField
										name='name'
										isEditable={true}
										handleChange={handleVideoData}
										value={formData?.name}
										required={true}
									/>
								</div>

								<div className='form-group'>
									<label>CATEGORY</label>
									<InputField
										name='category'
										isEditable={true}
										handleChange={handleVideoData}
										value={formData?.category}
										required={true}
									/>
								</div>

								<div className='form-group'>
									<label>DESCRIPTION</label>
									<TextAreaField
										name='description'
										isEditable={true}
										handleChange={handleVideoData}
										value={formData?.description}
										required={true}
									/>
								</div>
								{/* hide uploading of single content when chapters is activated */}
								{isChapterActive ? null : (
									<>
										<div className='form-group'>
											<label>UPLOAD SINGLE VIDEO</label>
											<Upload
												beforeUpload={beforeUpload}
												onChange={onChange}
												{...contentProps}
												accept='video/*'
											>
												<Button
													style={{
														color: "#959595",
														fontSize: "1rem",
														width: "100%",
													}}
													icon={
														<UploadOutlined style={{ fontSize: "1.2rem" }} />
													}
												>
													Click to upload
												</Button>
											</Upload>
										</div>
										<div
											style={{ backgroundColor: "red" }}
											className='progress-bar'
										></div>

										{/* //display preview when user uploads a file */}
										{isVideoSaved ? (
											<video
												style={{ borderRadius: "1rem" }}
												autoPlay={false}
												controls
												disablePictureInPicture
												playsInline
												src={videoSrc}
												width={"100%"}
												height={"200"}
												onLoadedMetadata={handleLoadedMetadata}
											>
												<source src={videoSrc} type='video/webm' />
												<source src={videoSrc} type='video/mp4' />
												<p>
													Your browser doesnt support HTML video. Here is a
													<a href={videoSrc}>link to the video</a> instead.
												</p>
											</video>
										) : null}
									</>
								)}

								<div className='form-group'>
									<label htmlFor='image'>ADD VIDEO THUMBNAIL</label>

									<label className='thumbnail_label' htmlFor='image'>
										<UploadOutlined style={{ fontSize: "1.2rem" }} /> Click to
										upload
										<input
											type='file'
											accept='image/*'
											name='image'
											id='image'
											onChange={thumbnailUpload}
										/>
									</label>
								</div>
								{isThumbnailSaved ? (
									<img
										className=''
										style={{ objectFit: "contain", height: "20rem" }}
										alt='video thumbnail'
										src={thumbnailUrl}
									/>
								) : null}

								<div className='addChapter mt-10 space-between'>
									<div className='flex gap-2'>
										Chapters
										<Switch
											checked={checked}
											onChange={handleToggle}
											inputProps={{ "aria-label": "controlled" }}
										/>
									</div>
								</div>

								{chapters.length > 0
									? chapters.map((data, index) => {
											return (
												<SingleContent
													singleChapterData={data}
													chapters={chapters}
													setChapters={setChapters}
													createChapterTemplate={createChapterTemplate}
													key={index}
													index={index}
													type={"video"}
												/>
											);
									  })
									: null}

								<ButtonGroup>
									<CustomButton
										type='submit'
										color='#ffffff'
										backgroundcolor='#003A50'
										// onClick={uploadContent}
									>
										<AiOutlineSave size={24} />
										{checked ? (
											<p>Upload all chapters</p>
										) : (
											<p>Upload content</p>
										)}
									</CustomButton>

									<CustomButton
										onClick={() => navigate("/education/video")}
										type='button'
										backgroundcolor='#FF7878'
										color='#ffffff'
									>
										<ImCancelCircle size={24} />
										<p>Cancel</p>
									</CustomButton>
								</ButtonGroup>
							</form>
						</AddContentTemplate>
					</FormAccordion>
				</AddproductWrapper>
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default AddVideo;
